module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yH9Ja5/tc-custom/9781488001567.jpg?1721404338928",
      "alt": "This image is the cover for the book CEO's Unexpected Child, Billionaires and Babies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("CEO's Unexpected Child, Billionaires and Babies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Life throws him an opportunity—and a woman—he can’t resist . . . A novel of twists of fate and ties that bind from the author of "), _c('i', [_vm._v("His Lover’s Little Secret")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("A shocking fertility clinic mix-up has resulted in Luca Moretti fathering a child with a woman he’s never met. There’s no way the CEO will walk away from his baby girl. But he has thirty days to convince her distractingly beautiful mother to do exactly what he wants."), _c('br'), _c('br'), _vm._v("Widow Claire Douglas is still reeling from the loss of her husband when she discovers a stranger has fathered her child. And the rich bachelor will stop at nothing to gain joint custody. How can she possibly fight a man with such money and power . . . and a charm she can’t resist?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andrea Laurence\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Andrea Laurence is an award-winning contemporary author who has been a lover of books and writing stories since she learned to read. A dedicated West Coast girl transplanted into the Deep South, she’s constantly trying to develop a taste for sweet tea and grits while caring for her husband and two spoiled golden retrievers. You can contact Andrea at her website: http://www.andrealaurence.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0